export default function Welcome() {
    return (
        <div className='mt-12 text-center'>
            <p className="text-4xl font-bold lg:text-6xl">poolesville <span className="text-primary">web</span> development <span className="text-secondary">club</span></p>
            <div className='mt-8 lg:text-xl font-lightbold'>
                <p>poolesville web development club blah blah blah.</p>
                <p>this website is currently under construction!</p>
            </div>
        </div>
    )
}